// MakingofaRobot
import React from 'react';
import MakingofaRobot from 'views/MakingofaRobot';

const LogisticsPage = () => {
  return <MakingofaRobot />;
};

export default LogisticsPage;
